/**
 * JsonOverlay.js — JSON view overlay on preview panel.
 *
 * Displays formatted, read-only JSON of the current mechanic config
 * with a copy-to-clipboard button. Strips empty arrays and undefined fields.
 *
 * Part of the Homebrew Workshop (Issue #82, Phase E: #180)
 */

import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

export default function JsonOverlay({ config }) {
  const [copied, setCopied] = useState(false);

  // Clean config for display — remove empty arrays and undefined/empty fields
  const cleanConfig = JSON.parse(JSON.stringify(config, (key, value) => {
    if (Array.isArray(value) && value.length === 0) return undefined;
    if (value === '' || value === undefined) return undefined;
    return value;
  }));

  const jsonStr = JSON.stringify(cleanConfig, null, 2);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(jsonStr);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback ignored — clipboard may not be available in all contexts
    }
  };

  return (
    <div className="mt-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-bold text-gray-400 uppercase">JSON Schema</h3>
        <button
          type="button"
          onClick={handleCopy}
          className="flex items-center gap-1 text-xs text-gray-500 hover:text-gray-300"
        >
          {copied ? <Check className="w-3 h-3 text-green-400" /> : <Copy className="w-3 h-3" />}
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <pre className="bg-gray-900 border border-gray-700 rounded-lg p-3 text-xs text-gray-300 overflow-x-auto max-h-96 overflow-y-auto font-mono">
        {jsonStr}
      </pre>
    </div>
  );
}
